import {UIEventHandler, useMemo, useState} from 'react'
import {Hub} from 'yougile-model'
import {useBoardStore} from './board-store'

const overscan = 1
const columnWidth = 296 + 8

interface UseVirtualItemsReturnType {
  virtualItems: {index: number; offset: number}[]
  onScroll: UIEventHandler<HTMLDivElement>
  setContainerEl: (el: HTMLElement) => void
}

export const useVirtualItems = (board: Hub): UseVirtualItemsReturnType => {
  const [state] = useBoardStore()

  const [scroll, setScroll] = useState(0)
  const [container, setContainerEl] = useState<HTMLElement>()

  const onScroll: UIEventHandler<HTMLDivElement> = e => {
    state.tasksRenderQueue.requestToUpdatePriorities()
    const el = e.target as HTMLDivElement
    if (!el) {
      return
    }
    setScroll(el.scrollLeft)
  }

  const virtualItems = useMemo(() => {
    if (state.currentGroups[0]?.location !== board.id) {
      return []
    }

    const containerWidth = container?.clientWidth ?? 0
    let startIndex = Math.floor(scroll / columnWidth)
    let endIndex = Math.ceil((scroll + containerWidth) / columnWidth)
    startIndex = Math.max(0, startIndex - overscan)
    endIndex = Math.min(state.currentGroups.length, endIndex + overscan)
    const renderItems = []

    for (let index = startIndex; index < endIndex; index++) {
      renderItems.push({
        index,
        offset: index * columnWidth
      })
    }

    return renderItems
  }, [scroll, board.id, state.currentGroups])

  return {virtualItems, onScroll, setContainerEl}
}
